import { Download, SquareArrowUpRight, Trash2 } from 'lucide-react'
import { cn } from '@/shared/lib/utils'
import type { CanvasAsset } from '@/entities/node/canvas-asset'
import Preview from "@/assets/images/ic_preview.svg"
import { Tip } from "@/shared/components/ui/tooltip";

interface ListNodeItemBarProps {
  asset: CanvasAsset
  nodeId: string
  onOpenPreview?: (asset: CanvasAsset) => void
  onAddToCanvas?: (asset: CanvasAsset) => void
  onDownload?: (asset: CanvasAsset) => void
  onDelete?: (asset: CanvasAsset) => void
  className?: string
  /** 失败状态：预览/添加到画布/下载禁用（灰色不可点击），仅删除可用 */
  isFailed?: boolean
  /** 更多操作菜单（替换默认的删除按钮） */
  moreAction?: React.ReactNode
}

/** 列表节点（宫格/列表视图）通用 Hover 操作栏：预览、添加到画布、下载、删除 */
export function ListNodeItemBar({
  asset,
  onOpenPreview,
  onAddToCanvas,
  onDownload,
  onDelete,
  className,
  isFailed,
  moreAction,
}: ListNodeItemBarProps) {
  /** 失败状态下禁用预览/添加到画布/下载 */
  const disabled = isFailed ?? false
  const actionClass = disabled
    ? 'opacity-30 cursor-not-allowed'
    : 'hover:bg-white/10 hover:text-white'

  return (
    <div className={cn('flex items-center gap-0.5 rounded-[10px] bg-black/40 backdrop-blur-[10px] px-1 py-0.5 opacity-0 transition-opacity group-hover:opacity-100', className)}>
      <Tip content={"预览"} delayDuration={0}>
          <button
                  type="button"
                  disabled={disabled}
                  className={cn('flex h-5 w-5 items-center justify-center rounded-full text-white/60 transition', actionClass)}
                  onClick={disabled ? undefined : (e) => {
                    e.stopPropagation()
                    onOpenPreview?.(asset)
                  }}
                >
                  <img alt="预览" className="h-4 w-4" src={Preview} />
                </button>
          </Tip>

      <Tip content={"添加到画布"} delayDuration={0}>
          <button
                  type="button"
                  disabled={disabled}
                  className={cn('flex h-5 w-5 items-center justify-center rounded-full text-white/60 transition', actionClass)}
                  onClick={disabled ? undefined : (e) => {
                    e.stopPropagation()
                    onAddToCanvas?.(asset)
                  }}
                >
                    <SquareArrowUpRight className="h-3.5 w-3.5" />
                </button>
          </Tip>

      <Tip content={"下载"} delayDuration={0}>
          <button
                  type="button"
                  disabled={disabled}
                  className={cn('flex h-5 w-5 items-center justify-center rounded-full text-white/60 transition', actionClass)}
                  onClick={disabled ? undefined : (e) => {
                    e.stopPropagation()
                    onDownload?.(asset)
                  }}
                >
                  <Download className="h-3.5 w-3.5" />
                </button>
          </Tip>

      {moreAction ? (
        moreAction
      ) : (
        onDelete && (
          <Tip content={"删除"} delayDuration={0}>
                      <button
                                  type="button"
                                  className="flex h-5 w-5 items-center justify-center rounded-full text-white/60 hover:bg-white/10 hover:text-white transition"
                                  onClick={(e) => {
                                    e.stopPropagation()
                                    onDelete(asset)
                                  }}
                                >
                                  <Trash2 className="h-3.5 w-3.5" />
                                </button>
                      </Tip>
        )
      )}
    </div>
  )
}
